import imageCompression from 'browser-image-compression';

const compressionOptions = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  fileType: 'image/jpeg',
  initialQuality: 0.8,
};

export const compressImage = async (file: File): Promise<File> => {
  try {
    // Skip compression for small files
    if (file.size < 100 * 1024) { // Less than 100KB
      return file;
    }

    const compressedFile = await imageCompression(file, compressionOptions);
    
    // Return original if compression didn't help
    if (compressedFile.size >= file.size) {
      return file;
    }
    
    console.log(`Compressed from ${(file.size / 1024 / 1024).toFixed(2)}MB to ${(compressedFile.size / 1024 / 1024).toFixed(2)}MB`);
    return compressedFile;
  } catch (error) {
    console.error('Error compressing image:', error);
    return file;
  }
};
